<lib-prod-grid
  [title]="prodGridTitle"
  [icon]="'dataset'"
  [columns]="prodGridColumns"
  [matTableDataSource]="matTableDataSource"
  [inputAction$]="inputAction$"
  [isAddButtonShown]="isAddButtonShown"
  [isAddButtonDisabled]="isAddButtonDisabled"
  [limitless]="true"
  (outputAction$)="outputActionEvents($event)"></lib-prod-grid>
